import { TextMagnifyingGlass } from "iconoir-react";

export function Welcome() {
  return (
    <div className="my-24 w-full flex flex-col space-y-3 items-center">
      <TextMagnifyingGlass
        height={50}
        width={50}
        className="stroke-2 text-brand-purple"
      />
      <h5 className="text-lg font-bold pt-4">Welcome to Dictionary!</h5>
      <p className="text-center text-gray-500 dark:text-gray-300">
        Search for any word and get its definition, synonyms, antonyms and
        examples.
      </p>
    </div>
  );
}